import { Card } from 'components/Card';
import { CardRow } from 'components/CardRow';
import { ModalScreenProps, ModalScreens } from 'components/Navigation/types';
import { NavigationHeader } from 'components/NavigationHeader';
import { PageScrollView } from 'components/Page';
import { useEsc } from 'hooks/useEsc';
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { NAVIGATE_MODAL_BACK, doReportingSelectReport } from 'store/actions';
import { selectRptReportList } from 'store/remote/selectors';

export const ReportsSelect: React.FC<
  ModalScreenProps<ModalScreens.ReportsSelect>
> = () => {
  const dispatch = useDispatch();

  const reportList = useSelector(selectRptReportList);

  const handleClose = React.useCallback(
    () => dispatch(NAVIGATE_MODAL_BACK()),
    [dispatch],
  );

  const handleSelect = React.useCallback(
    (id: string) => {
      dispatch(
        doReportingSelectReport({
          id,
          filter: { organisationIds: [] },
          key: null,
          loadData: false,
        }),
      );
    },
    [dispatch],
  );

  useEsc(handleClose);

  return (
    <PageScrollView
      header={
        <NavigationHeader
          heading="Pages"
          onPressCancelButton={() => dispatch(NAVIGATE_MODAL_BACK())}
        />
      }
    >
      {reportList.map((report) => (
        <Card key={report.id} marginBottomQuarter>
          <CardRow
            label={report.name}
            label2={
              report.typeIsDefault ? undefined : `Based on ${report.typeName}`
            }
            value={report.description}
            labelAlignTop
            onPress={() => handleSelect(report.id)}
          />
        </Card>
      ))}
    </PageScrollView>
  );
};
